// =============================================================================
// ExceptionLegend - Legenda dei motivi di assenza / presenza aggiuntiva
// =============================================================================
// Mostra solo le voci effettivamente presenti nel giorno visualizzato.

import { CalendarPlus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getReasonVisual } from '../utils/exceptionStyle';

interface LegendReason {
  id: string;
  name: string;
  color: string;
  icon: string;
}

interface LegendException {
  isAvailable: boolean;
  reason?: LegendReason | null;
}

export function ExceptionLegend({ exceptions }: { exceptions: LegendException[] }) {
  const { t } = useTranslation('settings');

  // Raggruppa le assenze per causale, deduplicando.
  const seen = new Set<string>();
  const entries: Array<{ key: string; label: string; color: string; icon: string }> = [];
  for (const e of exceptions) {
    if (e.isAvailable || !e.reason) continue;
    if (seen.has(e.reason.id)) continue;
    seen.add(e.reason.id);
    entries.push({
      key: e.reason.id,
      label: e.reason.name,
      color: e.reason.color,
      icon: e.reason.icon,
    });
  }

  const hasPresence = exceptions.some((e) => e.isAvailable);

  if (entries.length === 0 && !hasPresence) return null;

  return (
    <div className="flex items-center gap-x-4 gap-y-1 flex-wrap">
      <span className="text-xs text-gray-400">{t('exceptions.legendTitle')}</span>
      {entries.map((entry) => {
        const { Icon } = getReasonVisual(entry);
        return (
          <span key={entry.key} className="inline-flex items-center gap-1 text-xs" style={{ color: entry.color }}>
            <Icon className="w-3.5 h-3.5" />
            {entry.label}
          </span>
        );
      })}
      {hasPresence && (
        <span className="inline-flex items-center gap-1 text-xs text-emerald-600">
          <CalendarPlus className="w-3.5 h-3.5" />
          {t('exceptions.presence')}
        </span>
      )}
    </div>
  );
}
